var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"text-left max-content",attrs:{"variant":"light"},on:{"click":function($event){return _vm.$emit('btnClick')}}},[(_vm.selected)?_c('b-badge',{attrs:{"variant":"warning"}},[_c('i',{staticClass:"fa-solid fa-caret-left"})]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.entity.target)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }